import { Injectable, signal } from '@angular/core';
import { Login, Login_ } from './user';
import { StorageService } from '@core/storage-module/storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _loginData = signal<Login | null>(null);

  set loginData(v: Login) {
    this._StorageService.setItem('nex_usr_session', v);
    this._loginData.set(v);
  }

  restLoginData() {
    this._loginData.set(null);
  }

  get loginData() {
    return this._loginData() as any;
  }

  getPartialData(key?: Partial<Login_>): Login | string {
    if (key) {
      return (this.loginData as Login)[key] as any;
    } else {
      return this.loginData as Login;
    }
  }

  constructor(
    private _StorageService: StorageService
  ) {
    const data = this._StorageService.getItem('nex_usr_session');

    if (data) {
      this.loginData = data;
    }

  }

}
